import { __decorate } from "tslib";
import { AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { PaymentCustomer } from '../PaymentCustomer.js';
export class Customer extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.firstName = '';
        this.lastName = '';
        this.email = '';
        this.phone = '';
    }
    get name() {
        if (this.lastName === '') {
            return this.firstName;
        }
        if (this.firstName === '') {
            return this.lastName;
        }
        return this.firstName + ' ' + this.lastName;
    }
    toPaymentCustomer() {
        return PaymentCustomer.create({
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email,
            phone: this.phone,
        });
    }
}
__decorate([
    field({ decoder: StringDecoder })
], Customer.prototype, "firstName", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Customer.prototype, "lastName", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Customer.prototype, "email", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Customer.prototype, "phone", void 0);
//# sourceMappingURL=Customer.js.map